import {Pipe, PipeTransform} from '@angular/core';
import {ISummary} from "./ISummary";
import {LabelService} from "../../service/label/label.service";

@Pipe({
    name: 'getLabel'
})

export class GetLabelPipe implements PipeTransform {

    constructor(
        private readonly labelService: LabelService,
    ) {
    }

    public transform(field: ISummary, args: string = null): string {
        if (args === 'showCount') {
            const count: number = field.value?.split('¤¤')?.length;
            const titleValues: string = field.value?.split('¤¤ ').join('\n');
            return this.labelService.completeLabel('%label% : <strong title="%titleCode%">%value%</strong>', {
                label: field.label,
                value: count.toString() + " " + (count >1 && field.pluralLabel ? field.pluralLabel : field.label),
                titleCode: this.escapeHtml(titleValues)
            });
        }
        return this.labelService.completeLabel('%label% : <strong>%value%</strong>', {
            label: field.label,
            value: field.value
        });
    }

    private escapeHtml(text: string) {
        let map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, function (m) {
            return map[m];
        });
    }
}
